import React from "react";

const processSteps = [
  {
    title: "Discovery & Strategy",
    description: "We dive deep into your business goals, target audience, and competitors to craft a digital strategy aligned with your vision.",

  },
  {
    title: "Design & Prototyping",
    description: "Interactive wireframes, mockups, and branding alignment ensure you see and shape your project's look and feel at every stage.",
  },
  {
    title: "Development & Integration",
    description: "Built using modern frameworks (React, Laravel, Shopify, WordPress), fully responsive and secure.",
  },
  {
    title: "Testing & Launch",
    description: "Comprehensive QA, cross-browser testing, performance, and security audits ensure a flawless launch.",
  },
  {
    title: "Support & Scaling",
    description: "Post-launch monitoring, optimization, and growth strategies to keep your website ahead in a rapidly evolving digital landscape.",
  }
];

const Section6 = () => {
  return (
    <div className="w-full bg-white py-[30px] md:py-[50px]">
      <div className="w-[90%] md:w-[85%] mx-auto">
        <h2
          className="text-center leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold mb-10"
        >
          Our Process of Website Development: From Concept to Conversion
        </h2>


        <div className="flex justify-center flex-wrap gap-[25px] w-[100%] mx-auto">
          {processSteps.map((step, index) => (
            <div
              key={index}
              className={`${index % 2 === 0
                ? "bg-[#E42E35] text-white"
                : "bg-[#f5f5f5] text-[#373737]"
                } w-[100%] md:w-[48%] xl:w-[30%] p-[6%] md:p-[2%] rounded-2xl shadow-md`}
            >


              <h3 className="text-[20px] md:text-[22px] font-bold mb-3 leading-[26px]">
                {step.title}
              </h3>

              <p className="text-[14px] md:text-[15px] leading-[22px]">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Section6;
